const order = state => state.order;
const loaded = state => state.loaded;
const isAccessable = state => state.order.paymentType;
const waitingForGeneration = state => state.waitingForGeneration;
const needsPaymenRetry = state => state.needsPaymenRetry;
export default {
    order,
    isAccessable,
    loaded,
    waitingForGeneration,
    needsPaymenRetry
}